import { render, staticRenderFns } from "./ProdReceptionDetails.vue?vue&type=template&id=856e729e&"
import script from "./ProdReceptionDetails.vue?vue&type=script&lang=js&"
export * from "./ProdReceptionDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProdReceptionDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports